import type { BranchCategory } from '@festina/configuration-general-types/configuration'
import { type FormikProps, FormikSelect } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { BranchCategoryIcon } from '../../branchNameWithStatus/BranchCategoryIcon'
import type { BranchCreationInput } from '../types'
import { useBranchCategoryTranslations } from '../useBranchCategoryTranslations'
import { validate } from './helpers'

type Props = {
  state: FormikProps<BranchCreationInput>
  allowedCategories: BranchCategory[]
}

export const CategorySelectionStep = ({
  state: { values },
  allowedCategories,
}: Props) => {
  const translate = useTranslate()
  const categoryTranslations = useBranchCategoryTranslations()
  const categoryDescriptions: Record<BranchCategory, string> = {
    main: translate(
      'branchCreationWizard.categorySelectionStep.mainDescription',
    ),
    none: translate(
      'branchCreationWizard.categorySelectionStep.noneDescription',
    ),
    feature: translate(
      'branchCreationWizard.categorySelectionStep.featureDescription',
    ),
    release: translate(
      'branchCreationWizard.categorySelectionStep.releaseDescription',
    ),
  }

  return (
    <>
      <p>
        {translate('branchCreationWizard.categorySelectionStep.description')}
      </p>
      <FormikSelect
        options={allowedCategories}
        name={validate('category')}
        label={translate('branchCreationForm.category.label')}
        renderFn={(category) => (
          <div className="flex gap-x-2">
            <BranchCategoryIcon category={category} />
            <div>{categoryTranslations[category]}</div>
          </div>
        )}
        shouldShowClearButton={false}
      />
      <p>{categoryDescriptions[values.category]}</p>
    </>
  )
}
